import { QueryClient } from "react-query";

export { QueryClientProvider } from "react-query";

type ErrorWithStatus = {
  response?: {
    status?: number;
  };
};

const getStatusCode = (error?: ErrorWithStatus) => error?.response?.status ?? 0;

// React Query has in-memory cache which requires that you use the same instance of QueryClient to
// benefit from it. Otherwise each instance gets it's own copy of cache.
/**
 * Global React Query Query Client instance.
 *
 * Intended for use on the client-side. For a server-side instance, see our `withQueryClient`
 * subroutine.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        const status = getStatusCode(error as ErrorWithStatus);

        // Target only 500 errors
        if (status >= 500 && status < 600) {
          // Max 3 requests. 1 initial (0 failure count), 2 retry
          if (failureCount < 2) {
            return true;
          }
        }

        return false;
      },
      retryDelay: (attempt) => {
        // Retry with exponential backoff from 4s
        return 2 ** attempt * 2000;
      },
      retryOnMount: false,
    },
  },
});
